import { point } from '@turf/helpers';
import html2Canvas from 'html2canvas';
import {icons} from "../config/constant"

import "./poiImg.css";

export const htmlToBase64OfImg = ({html, className, options = {}}) => {
    let box = document.getElementById("transform_box");
    box.className = className;
    if(typeof html === "string") {
        box.innerHTML = html;
    }else if(html instanceof HTMLElement) {
        box.innerHTML = "";
        box.appendChild(html);
    }else {
        new Error(`htmlToBase64OfImg need a string or HTMLElement! It can't be ${typeof html}!`)
    };
    return new Promise((resolve, reject) => {
        html2Canvas(box, {backgroundColor: null, ...options}).then((canvas) => {
            const img = canvas.toDataURL();
            resolve({img, element: box});
        }).catch(reject);
    });
}

const createImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = ()=> {
        resolve(img);
      };
      img.onerror = () => {
        reject(img)
      }
    });
}

export const defaultPoiIconSpare = ({first, second, icon, third}) => {
    if(third){
        return htmlToBase64OfImg({
            html: `
                <div class="default_poi_img">
                    <img class="bubble" src="${icons.bubble1}" />
                    <div class="text">
                        <div class="one">
                        ${first}
                        </div>
                        <div class="two">
                            ${second}
                        </div>
                        <div class="third">
                            ${third}
                        </div>
                    </div>
                    <div class="icon">
                        <img src="${icons.point}" />
                    </div>
                </div>
            `,
            className: "default_box"
        });
    }else{
        return htmlToBase64OfImg({
            html: `
                <div class="default_poi_img">
                    <img class="bubble" src="${icons.bubble1}" />
                    <div class="text">
                        <div class="one">
                        ${first}
                        </div>
                        <div class="two">
                            ${second}
                        </div>
                    </div>
                    <div class="icon">
                        <img src="${icons.point}" />
                    </div>
                </div>
            `,
            className: "default_box"
        });
    }
   
}

export const defaultPoiIcon = ({first, second, icon,third}) => {
    const canvasBox = document.createElement("canvas");
    canvasBox.width = 176;
    if(third){
        canvasBox.height = 176;
    }else{
        canvasBox.height = 134;
    }
    
    const cvsCtx = canvasBox.getContext('2d');
    cvsCtx.clearRect(0, 0, canvasBox.width, canvasBox.height);
    cvsCtx.textAlign = 'center';
    cvsCtx.fillStyle = "#00ffff";
    let imgCount = 0;
    return new Promise((resolve, reject) => {
        const runResolve = base64Img => imgCount === 2 && resolve({img: base64Img});
        if(third){
            createImage(icons.bubble3).then((result) => {
                cvsCtx.drawImage(result, 0, 0, 176, 176);
                cvsCtx.font = '16px sans-serif';
                cvsCtx.fillText(first, 88, 32);
                cvsCtx.fillText(second, 88, 58);
                cvsCtx.fillText(third, 88, 82);
                imgCount++
                const base64Img = canvasBox.toDataURL();
                runResolve(base64Img);
            });
        }else{
            createImage(icons.bubble).then((result) => {
                cvsCtx.drawImage(result, 0, 0, 176, 134);
                cvsCtx.font = '16px sans-serif';
                cvsCtx.fillText(first, 88, 26);
                cvsCtx.fillText(second, 88, 48);
                imgCount++
                const base64Img = canvasBox.toDataURL();
                runResolve(base64Img);
            });
        }
        
        if(icon) {
            createImage(icon).then(imgEl => {
                cvsCtx.drawImage(imgEl, 0, 0, 0, 0);
                imgCount++;
                const base64Img = canvasBox.toDataURL();
                runResolve(base64Img);
            })
        }else {
            imgCount++;
        }
    });
}

export const geologyPoiIcon = ({hor, name, ver, x, y, z}) => {
    const canvasBox = document.createElement("canvas");
    canvasBox.width = 90;
    canvasBox.height = 230;
    const cvsCtx = canvasBox.getContext('2d');
    cvsCtx.clearRect(0, 0, canvasBox.width, canvasBox.height);
    cvsCtx.textAlign = 'center';
    cvsCtx.fillStyle = "#00ffff";
    return new Promise((resolve, reject) => {
        createImage(icons.geologybg2).then((result) => {
            cvsCtx.drawImage(result, 0, 0, 90, 230);
            cvsCtx.font = '12px sans-serif';
            cvsCtx.fillText("地质", 45, 25);
            cvsCtx.fillText(name, 45, 50);
            cvsCtx.fillText(`x位移 ${x}`, 45, 70);
            cvsCtx.fillText(`y位移 ${y}`, 45, 90);
            cvsCtx.fillText(`z位移 ${z}`, 45, 110);
            cvsCtx.fillText(`水平位移 ${hor}`, 45, 130);
            cvsCtx.fillText(`垂直位移 ${ver}`, 45, 150);
            const base64Img = canvasBox.toDataURL();
            resolve({img: base64Img});
        });
    });
}


// export const geologyPoiIcon = ({hor, name, ver, x, y, z}) => {
//     return htmlToBase64OfImg({
//         html: `<div class="geology_box">
//                 <img class="Environmentbg" src="${icons.geologybg}" />
//                 <div class="Environmenttext">
//                     <div class="one">地质</div>
//                     <div class="info">
//                       <div class="two"> ${name}</div>
//                       <div class="two"> X位移 ${x}</div>
//                       <div class="two"> Y位移 ${y}</div>
//                       <div class="two"> Z位移 ${z}</div>
//                       <div class="two"> 水平位移 ${ver}</div>
//                       <div class="two"> 垂直位移 ${hor}</div>
//                     </div>
//                 </div> 
//             </div>`,
//         className: "geology_default_box"
//     });
// }
export const environmentPoiIcon = ({first, second}) => {
    return htmlToBase64OfImg({
        html: `<div class="hj_box">
                <img class="Environmentbg" src="${icons.Environmentbg}" />
                <div class="hjtext">
                    <div class="one">
                    ${first}
                    </div>
                    <div class="two">
                    ${second}
                    </div>
                </div> 
            </div>`,
        className: "default_box"
    });
}

export const pointClick = {
    liuliang:{
        default() {},
        keliujiance() {},
        midujiance() {},
        tingchechang() {},
        zhinengcesuo() {}
    },
    tongxun:{
        default() {}
    },
    huanjing:{
        wendu() {},
        shidu() {},
        qiya() {},
        fuyanglizi() {},
        pm25() {},
        pm10() {}
    },
    shebei:{
        default() {

        },
        camera() {},
        led() {},
        broadcast() {},
        sos() {},
        wifi() {}
    },
    dizhi:{
        defalut() {}
    },
    xiangmu:{
        
    }
}